import React from 'react'
import {Icon} from '@therms/atalaya'
import {MobileMenuLink} from '@src/modules/Layout/shared/MobileMenuLink'
import {PATROL_ROUTES} from '../../constants'
import {FaRoute} from 'react-icons/fa'

function PatrolMobileMenuLink() {
  return (
    <MobileMenuLink to={PATROL_ROUTES.__ROOT__}>
      <div className="flex flex-col items-center">
        <Icon Icon={FaRoute} size="sm" />
        <span>Patrol</span>
      </div>
    </MobileMenuLink>
  )
}

export {PatrolMobileMenuLink}
